import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonComponent, MbsSize } from 'mbs-ui-kit';
import { interval, map, Observable, tap } from 'rxjs';
import { startWith, takeWhile } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-reserve-auth-resend-code-button',
  templateUrl: './reserve-auth-resend-code-button.component.html',
  styleUrls: ['./reserve-auth-resend-code-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonComponent]
})
export class ReserveAuthResendCodeButtonComponent implements OnChanges {
  @Input() seconds = 0;
  @Input() loading = false;
  @Output() onResend = new EventEmitter();

  public readonly size = MbsSize;

  public isResendAvailable = false;
  public secondsLeft = 0;
  public interval: Observable<number>;

  ngOnChanges() {
    this.startTimer();
  }

  public onClick() {
    !this.loading && this.isResendAvailable && this.onResend.emit();
  }

  private startTimer() {
    this.isResendAvailable = false;
    this.secondsLeft = this.seconds;

    this.interval = interval(1000).pipe(
      startWith(this.secondsLeft),
      tap(() => this.secondsLeft--),
      tap(() => {
        if (this.secondsLeft <= 0) {
          this.isResendAvailable = true;
        }
      }),
      map(() => this.secondsLeft),
      takeWhile(() => this.secondsLeft >= 0),
      untilDestroyed(this)
    );
  }
}
